import { render } from "./MfIcon.vue?vue&type=template&id=e1961fce&scoped=true"
import script from "./MfIcon.vue?vue&type=script&lang=js"
export * from "./MfIcon.vue?vue&type=script&lang=js"

import "./MfIcon.vue?vue&type=style&index=0&id=e1961fce&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1961fce"]])

export default __exports__